import { render, staticRenderFns } from "./info-notice.vue?vue&type=template&id=b132d4ce&scoped=true"
import script from "./info-notice.vue?vue&type=script&lang=js"
export * from "./info-notice.vue?vue&type=script&lang=js"
import style0 from "./info-notice.vue?vue&type=style&index=0&id=b132d4ce&prod&lang=less&scoped=true"
import style1 from "./info-notice.vue?vue&type=style&index=1&id=b132d4ce&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b132d4ce",
  null
  
)

export default component.exports